import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './AuthenticatedSignIn.scss';
import ReadMoreLessText from 'common/ReadMoreLessText';
import TextHeader from './TextHeader';
import PrivacyPolicyLink from 'common/PrivacyPolicyLink';
import TermsOfUseLink from 'common/TermsOfUseLink';
import useStarfishAPI from '../hooks/useStarfishAPI';
import { getWord } from 'utils/tenant';
import KioskHeader from "./KioskHeader";

/**
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} Renders the sign in page that routes to the institution's authentication page (used for deep links).
 */
function AuthenticatedSignIn(props) {
    const [response, callAPI] = useStarfishAPI();

    useEffect(() => {
        if (!response.success && !response.pending) callAPI('../virtual-kiosk/reset.html');
    }, []);

  return (
    <div>
      <KioskHeader name={props.kioskName}
                   showWaitTime={false}
                   kioskImageUrl={props.kioskImageUrl}
                   setError={props.setError} />
      <div className={css['content']}>
        <TextHeader
          upperText={props.greetingText}
          lowerText={props.mainHeader}
        />
        <div className={css['instructions']}>
          <ReadMoreLessText text={props.instructionsText} />
        </div>
        <button className={css['sign-in']}
                onClick={() => {
                    location.assign(location.href.replace(
                        /\/virtual-kiosk\/signIn.html(.*)/,
                        '/dl/virtual-kiosk/launch.html?kioskId=' + props.kioskId))
                }}>
            <img src="../images/starfish/student_starfish.png" aria-hidden="true" width="56" height="56" />
            <div>
                <b> {props.showToProspectiveStudents ? 'Are you a Current Student?' : 'Need to check-in to a service?'} </b>
                <br/>
                Login to {getWord('Starfish')} to check-in to meet with someone.
            </div>
        </button>
        { props.showToProspectiveStudents &&
            <button className={css['sign-in']} onClick={props.goToProspectiveForm}>
                <img src="../images/starfish/happy_starfish_blue.png" aria-hidden="true" width="56" height="56" />
                <div>
                    <b>Not a student? Not a problem.</b>
                    <br/>
                    Login with your email address or sign up to check-in.
                </div>
            </button>
        }
      </div>
      <div className={css['footer-container']}>
          <TermsOfUseLink />
          <PrivacyPolicyLink />
      </div>
    </div>
  );
}

AuthenticatedSignIn.propTypes = {
  kioskId: PropTypes.number.isRequired,
  kioskName: PropTypes.string.isRequired,
  kioskImageUrl: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  greetingText: PropTypes.string,
  mainHeader: PropTypes.string,
  instructionsText: PropTypes.string,
  prospectiveStudentsText: PropTypes.string,
  showToProspectiveStudents: PropTypes.bool.isRequired,
  goToProspectiveForm: PropTypes.func.isRequired
};

export default AuthenticatedSignIn;
